<template>
  <div class="products">
    <el-table
      class="list"
      ref="singleTable"
      :data="list"
      highlight-current-row
      @current-change="handleCurrentChange"
      height="calc(100% - 32px - 97px)"
      style="width: 100%"
    >
      <el-table-column label="商品信息" width="411">
        <template slot-scope="scope">
          <div
            class="radio"
            :class="{ checked: currentId == scope.row.id }"
          ></div>
          <el-image class="icon" :src="scope.row.icon" fit="cover"></el-image>
          <div class="info">
            <p class="name">{{ scope.row.name }}</p>
            <p class="tag">{{ scope.row.tag }}</p>
            <p class="id">ID {{ scope.row.id }}</p>
            <p class="price">
              价格<span>{{ scope.row.price }}</span
              >元
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="type" label="类目" align="center" width="64">
      </el-table-column>
      <el-table-column property="sales" label="销量" align="center">
      </el-table-column>
      <el-table-column property="stock" label="库存" align="center">
      </el-table-column>
      <el-table-column
        property="time"
        label="上架时间"
        sortable
        align="center"
        width="118"
      >
      </el-table-column>
    </el-table>

    <el-pagination
      class="page"
      background
      :current-page.sync="params.page"
      :page-size="params.limit"
      layout="total, prev, pager, next"
      :total="5"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params: {
        page: 1,
        limit: 5,
      },
      list: [
        {
          id: "3518886746114937177",
          icon: require("@/assets/images/simulation/product1.png"),
          name: "2020夏季新款学院风女装女式中长款宽",
          tag: "松显瘦圆领纯色短袖套头T恤",
          price: 49,
          type: "T恤",
          sales: 150,
          stock: 2000,
          time: "2021-12-14 17:07:05",
        },
        {
          id: "3518884570328101061",
          icon: require("@/assets/images/simulation/product2.png"),
          name: "2021新款秋装秋季长袖T恤男卫衣打底",
          tag: "衫男士圆领套头卫衣男",
          price: 26.6,
          type: "T恤",
          sales: 86,
          stock: 596,
          time: "2021-12-14 17:06:58",
        },
        {
          id: "3518882470483382653",
          icon: require("@/assets/images/simulation/product3.png"),
          name: "2021新款秋季长袖T恤男卫衣男士圆领",
          tag: "套头爆款",
          price: 22.9,
          type: "T恤",
          sales: 50,
          stock: 5950,
          time: "2021-12-10 15:23:05",
        },
        {
          id: "3518885796935557249",
          icon: require("@/assets/images/simulation/product4.png"),
          name: "2020夏季韩版棉质宽松花朵图案大码女",
          tag: "装中长款上衣短袖t恤女",
          price: 39,
          type: "T恤",
          sales: 0,
          stock: 3000,
          time: "2021-12-04 17:08:23",
        },
        {
          id: "3518459244397606152",
          icon: require("@/assets/images/simulation/product5.png"),
          name: "秋冬新款重工艺棉质男卫衣潮流个性圆",
          tag: "领衫舒适休闲长袖t恤内搭",
          price: 48,
          type: "T恤",
          sales: 450,
          stock: 5550,
          time: "2021-12-02 09:57:54",
        },
      ],
      currentId: null,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentId = val.id;
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="less" scoped>
.products {
  height: 100%;

  ::v-deep .list {
    overflow: auto;
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
    .el-table__row {
      cursor: pointer;
    }
    .radio {
      display: inline-block;
      margin-right: 10px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid #e0e0e0;
      vertical-align: 30px;
      &.checked {
        position: relative;
        border-color: #28304c;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #28304c;
        }
      }
    }
    .icon {
      width: 86px;
      height: 86px;
    }
    .info {
      display: inline-block;
      margin-left: 20px;
      .name,
      .tag {
        line-height: 22px;
        text-overflow: ellipsis;
        color: #333;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .id,
      .price {
        margin-top: 4px;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        span {
          margin: 0 3px;
          color: rgba(0, 0, 0, 0.9);
        }
      }
    }
  }
  ::v-deep .page {
    margin-top: 85px;
    text-align: end;
    .el-pager li:not(.disabled).active {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #edf1fd;
    }
  }
}
</style>